var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleNavRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 21,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 20.5,
    stroke: "#F5F5F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3225 12.6163C22.4241 12.5144 22.5448 12.4336 22.6777 12.3784C22.8106 12.3233 22.9531 12.2949 23.0969 12.2949C23.2408 12.2949 23.3832 12.3233 23.5161 12.3784C23.649 12.4336 23.7697 12.5144 23.8713 12.6163L31.1425 19.8875C31.2237 19.9685 31.288 20.0646 31.3319 20.1705C31.3758 20.2763 31.3984 20.3898 31.3984 20.5044C31.3984 20.619 31.3758 20.7324 31.3319 20.8383C31.288 20.9441 31.2237 21.0403 31.1425 21.1213L23.8713 28.3925C23.4425 28.8212 22.7513 28.8212 22.3225 28.3925C21.8938 27.9637 21.8938 27.2725 22.3225 26.8438L28.6575 20.5L22.3138 14.1563C21.8938 13.7363 21.8938 13.0363 22.3225 12.6163Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_131",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_131",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNavRight);
export default __webpack_public_path__ + "static/media/circle-nav-right.d4531a55af25f41154b61c575231cd9f.svg";
export { ForwardRef as ReactComponent };